import axios from 'axios';
import { defaultProductionApiUrl, resolveApiUrl } from './apiConfig';
// import { DEFAULT_CODE } from '../../components/user/CodeContext';

export const liveApiUrl = defaultProductionApiUrl;
export const apiUrl = resolveApiUrl();

export const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // 'Escape-Code': DEFAULT_CODE,
  },
});

export default axiosInstance;
